/** Page Designer component type for a single promotional banner message. */
export const PROMO_BANNER_TYPE_ID = 'promoBanner';

/** Locale that receives the mobile app download banner. */
export const APP_BANNER_LOCALE_ID = 'en-GB';

/** Below this the header always shows its full-height layout. */
export const HEADER_CONDENSE_THRESHOLD_PX = 120;

/** `labelKey` resolves against the `header` i18n namespace. */
export const MEGA_MENU_ITEMS = [
    { id: 'brands', labelKey: 'megaMenu.brands', to: '/brands' },
    { id: 'new-in', labelKey: 'megaMenu.newIn', to: '/new-in' },
    { id: 'offers', labelKey: 'megaMenu.offers', to: '/offers' },
    { id: 'inside-space', labelKey: 'megaMenu.insideSpace', to: '/inside-space' },
    { id: 'trending', labelKey: 'megaMenu.trending', to: '/trending' },
] as const;

export type MegaMenuItemDefinition = (typeof MEGA_MENU_ITEMS)[number];
